<template>
    <div class="backdrop" style="z-index:100" @click.self="onNo">
        <div class="message-box-2" :class="{ 'message-box-2-with-dropdown': hasDropdown }">
            <div style="display:flex;justify-content:center">
                {{ messageBoxModel.caption }}
            </div>
            <div style="margin-bottom:10px">
                <hr class="header-divider" />
            </div>
            <div style="display:flex;justify-content:space-between; flex-direction: column;height:100%">
                <div style="text-align:left">
                    <div v-for="message in messageBoxModel.message" :key="message" id="message_box_v2_message">{{ message }}&nbsp;</div>
                    <div v-if="hasDropdown" style="margin-top:10px" id="message_box_v2_dropdown_container">
                        <label>{{ messageBoxModel.dropdownLabel }}</label>
                        <select v-model="selectedReason" style="width:100%;margin-top:4px" id="message_box_v2_dropdown">
                            <option value="" disabled>Select a reason...</option>
                            <option v-for="option in messageBoxModel.dropdownOptions" :key="option" :value="option">{{ option }}</option>
                        </select>
                        <textarea
                            v-if="selectedReason === messageBoxModel.dropdownOtherValue"
                            v-model="otherText"
                            placeholder="Please specify..."
                            style="width:100%;margin-top:6px;resize:vertical"
                            rows="2"
                            id="message_box_v2_other_text"
                        ></textarea>
                        <div v-if="validationError" style="color:var(--delete-color);font-size:12px;margin-top:4px" id="message_box_v2_validation_error">{{ validationError }}</div>
                    </div>
                </div>
                <div class="message-box-2-button-bar">
                    <button class="administrator-button message-box-2-button" @click="onYes" ref="btnYes" v-show="messageBoxModel.btnYes" id="message_box_v2_yes">
                        {{ messageBoxModel.btnYesText }}
                    </button>
                    <button class="administrator-button message-box-2-button" @click="onNo" ref="btnNo" v-show="messageBoxModel.btnNo" id="message_box_v2_no">
                        {{ messageBoxModel.btnNoText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { getCurrentInstance } from "@vue/runtime-core";

export default {
    props: ["messageBoxModel"],
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;

        const btnNo = ref(null);
        const btnYes = ref(null);

        const hasDropdown = computed(() => props.messageBoxModel.dropdownOptions.length > 0);
        const selectedReason = ref("");
        const otherText = ref("");
        const validationError = ref("");

        const onNo = () => {
            emitter.emit("message-box-no-" + props.messageBoxModel.callbackId);
            emit("on-close");
        };

        const onYes = () => {
            if (hasDropdown.value) {
                if (!selectedReason.value) {
                    validationError.value = "Please select a reason.";
                    return;
                }
                if (selectedReason.value === props.messageBoxModel.dropdownOtherValue && !otherText.value.trim()) {
                    validationError.value = "Please specify a reason.";
                    return;
                }
            }

            const reason = selectedReason.value === props.messageBoxModel.dropdownOtherValue ? otherText.value.trim() : selectedReason.value;
            emitter.emit("message-box-" + props.messageBoxModel.callbackId, hasDropdown.value ? reason : undefined);
            emit("on-close");
        };

        onMounted(() => {
            if (props.messageBoxModel.defaultYes) {
                btnYes.value.focus();
                btnNo.value.classList.add("button-cancel")
            } else {
                btnNo.value.focus();
                btnYes.value.classList.add("button-cancel")

                if (!props.messageBoxModel.btnYes) {
                    btnNo.value.classList.add("button-cancel")
                }
            }
        });

        return { btnNo, btnYes, hasDropdown, selectedReason, otherText, validationError, onNo, onYes };
    }
};
</script>

<style scoped>
/* @media (orientation: landscape) { */
@media (pointer: fine), (pointer: none) {
    .message-box-2 {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -105px;
        margin-left: -255px;
        width: 500px;
        height: 200px;
        background: var(--main-background);
        border-radius: 10px;
        padding: 10px;
        border: 1px solid var(--card-body-border);
    }
}


/* @media (orientation: portrait) { */
@media (pointer: coarse)  {    
    .message-box-2 {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -105px;
        margin-left: -255px;
        width: 500px;
        height: 200px;
        background: var(--main-background);
        border-radius: 10px;
        padding: 10px;
        border: 1px solid var(--card-body-border);
    }
}

.message-box-2-with-dropdown {
    height: 300px !important;
    margin-top: -155px !important;
}

.message-box-2-button-bar {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
    margin: 0px;
}

.message-box-2-button {
    /* background-color: cornflowerblue; */
    /* color: var(--button-color); */
    padding: 10px;
    margin-right: 10px;
    /* width: 75px;
    cursor: pointer; */
}
</style>
